import React, { useMemo, useState } from 'react';
import intl from 'react-intl-universal';
import { store } from 'Store/store.index';
import './customize-quick-access-toolbar.scss';

import UndoButton from './components/UndoButton';
import RedoButton from './components/RedoButton';

import W_SAVE from 'assets/HeaderContainer/w_save.svg';
import W_SAVEAS from 'assets/HeaderContainer/w_saveas.svg';
import W_PRINT from 'assets/HeaderContainer/w_print.svg';
import W_UNDO from 'assets/HeaderContainer/w_undo.svg';
import W_REDO from 'assets/HeaderContainer/w_redo.svg';
import W_CREATE from 'assets/HeaderContainer/w_create.svg';
import W_OPEN from 'assets/HeaderContainer/w_open.svg';
import W_DOWNLOAD from 'assets/HeaderContainer/w_download.svg';
import B_SAVE from 'assets/HeaderContainer/b_save.svg';
import B_SAVEAS from 'assets/HeaderContainer/b_saveas.svg';
import B_PRINT from 'assets/HeaderContainer/b_print.svg';
import B_UNDO from 'assets/HeaderContainer/b_undo.svg';
import B_REDO from 'assets/HeaderContainer/b_redo.svg';
import B_CREATE from 'assets/HeaderContainer/b_create.svg';
import B_OPEN from 'assets/HeaderContainer/b_open.svg';
import B_DOWNLOAD from 'assets/HeaderContainer/b_download.svg';
import CustomIcon from 'assets/HeaderContainer/custom_access.svg';
import { Tooltip, Popover, Checkbox } from 'antd';
import { MULTI_TABS_TYPES } from 'Components/MultiTabsBar/contant';
import { isCNDomain } from 'Utils/utils';
import { isWindows } from 'Utils/device';

const CustomizeQuickAccessToolbar = (props) => {
  const { serviceModeOfClientInfo } = store.appStore;
  const isDownloadBtn = Boolean(serviceModeOfClientInfo && isWindows);
  let saveTipKey = 'Save';
  if (!isDownloadBtn) {
    if (isCNDomain()) {
      saveTipKey = 'SaveAsCNAreaTooltip';
    } else {
      saveTipKey = 'SaveSameSource';
    }
  }
  if (serviceModeOfClientInfo && isWindows) {
    saveTipKey = 'saveToLocalTip';
  }
  const defaultToolList = [
    {
      name: 'undo', wicon: W_UNDO, bicon: B_UNDO, tip: 'undo', sel: true,
    }, {
      name: 'redo', wicon: W_REDO, bicon: B_REDO, tip: 'redo', sel: true,
    }, {
      name: 'download', wicon: W_DOWNLOAD, bicon: B_DOWNLOAD, tip: 'downloadFile', sel: true,
    }, {
      name: 'save', wicon: W_SAVE, bicon: B_SAVE, tip: saveTipKey, sel: true,
    }, {
      name: 'open', wicon: W_OPEN, bicon: B_OPEN, tip: 'customOpen', sel: true,
    }, {
      name: 'create', wicon: W_CREATE, bicon: B_CREATE, tip: 'customCreate', sel: true,
    }, {
      name: 'print', wicon: W_PRINT, bicon: B_PRINT, tip: 'Print', sel: true,
    }, {
      name: 'saveas', wicon: W_SAVEAS, bicon: B_SAVEAS, tip: 'customSaveAs', sel: false,
    },
  ];

  const needDownload = useMemo(() => {
    const { docDriveName } = store.docStore;
    if (docDriveName === 'Storage'
      || (!isCNDomain() && docDriveName && docDriveName !== 'Storage')
    ) {
      return true;
    }
    return false;
  }, [store.docStore.docDriveName, store.appStore.serviceModeOfClientInfo]);

  const fixToolList = (list) => {
    const { serviceModeOfClientInfo } = store.appStore;
    const { docDriveName } = store.docStore;
    const isDownloadBtn = Boolean(serviceModeOfClientInfo && isWindows);
    if (needDownload) {
      if (isDownloadBtn || docDriveName === 'Storage') {
        return list.filter(i => i.name !== 'save');
      } else {
        return list;
      }
    }
    return list.filter(i => i.name !== 'download');
  };

  const getFromLocal = () => {
    const savedStr = localStorage.getItem('customToolbar');
    if (!savedStr) {
      return fixToolList(defaultToolList);
    }
    const savedList = JSON.parse(savedStr);
    const newToolList = defaultToolList.map(item => {
      const savedItem = savedList.find(i => i.name === item.name);
      if (savedItem) {
        item.sel = savedItem.sel;
      }
      return item;
    });
    return fixToolList(newToolList);
  };

  const [toolList, setToolList] = useState(() => getFromLocal());

  const [open, setOpen] = useState(false);
  const { clickHandle, hasDoc, multiTabsTabPaneActiveType, isEnablePrint, isProtectedView } = props;

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const saveToLocal = () => {
    const saveList = toolList.map(item => {
      return {
        name: item.name,
        sel: item.sel,
      };
    });
    localStorage.setItem('customToolbar', JSON.stringify(saveList));
  };

  const changeSel = (name, checked) => {
    const newToolList = toolList.map(item => {
      if (item.name === name) {
        item.sel = checked;
      }
      return item;
    });
    setToolList(newToolList);
    saveToLocal();
  };

  const getToolList = () => {
    return (<>
      <dl>
        <dt>{intl.get('HeaderContainer.customToolbar')}:</dt>
        {toolList.map(item => (
          <dd key={`custom_check_${item.name}`}>
            <span>
              <img src={item.bicon} />
              <span>{item.name === 'save' ? 'Save' : intl.get(`HeaderContainer.${item.tip}`)}</span>
            </span>
            <Checkbox checked={item.sel} onChange={(e) => changeSel(item.name, e.target.checked)} />
          </dd>
        ))}
      </dl>
    </>);
  };

  return (<div className='custom-bar-box'>
    {hasDoc ? toolList.map((item) => {
      if (item.name === 'undo') {
        return <UndoButton className={item.sel ? '' : 'toolbar-hide-item'} key={`custom_${item.name}`} icon={item.wicon} />;
      }

      if (item.name === 'redo') {
        return <RedoButton className={item.sel ? '' : 'toolbar-hide-item'}  key={`custom_${item.name}`} icon={item.wicon} />;
      }

      if (multiTabsTabPaneActiveType === MULTI_TABS_TYPES.DOC) {
        if (item.name === 'print') {
          return (<Tooltip key={`custom_${item.name}`} title={intl.get(`HeaderContainer.${item.tip}`)}>
            <img className={`${item.sel ? '' : 'toolbar-hide-item'} ${isEnablePrint ? '' : 'disable-normal'}`} src={item.wicon} onClick={() => clickHandle(item.name)} />
          </Tooltip>);
        }
        if (['open', 'create'].includes(item.name)) {
          return (<Tooltip key={`custom_${item.name}`} title={intl.get(`HeaderContainer.${item.tip}`)}>
            <img className={`${item.sel ? '' : 'toolbar-hide-item'}`} src={item.wicon} onClick={() => clickHandle(item.name)} />
          </Tooltip>);
        }
      }

      if (['download', 'save'].includes(item.name)) {
        return (<Tooltip key={`custom_${item.name}`} title={intl.get(`HeaderContainer.${item.tip}`)}>
          <img className={`${item.sel ? '' : 'toolbar-hide-item'} ${isProtectedView ? 'disable-normal' : ''}`} src={item.wicon} onClick={() => clickHandle(item.name)} />
        </Tooltip>);
      }

      return (<Tooltip key={`custom_${item.name}`} title={intl.get(`HeaderContainer.${item.tip}`)}>
        <img className={`${item.sel ? '' : 'toolbar-hide-item'}`} src={item.wicon} onClick={() => clickHandle(item.name)} />
      </Tooltip>);
    }) : null}
    <Tooltip title={intl.get('HeaderContainer.customToolbar')}>
      <Popover
        content={getToolList}
        trigger='click'
        open={open}
        onOpenChange={handleOpenChange}
        overlayClassName='custom-toolbar-popover'
        placement='bottomLeft'
      >
        <img src={CustomIcon} />
      </Popover>
    </Tooltip>
  </div>);
};
export default CustomizeQuickAccessToolbar;


